import React from "react";
import About from "../components/About";
const AboutUsScreen = () => {
  return <About />;
};

export default AboutUsScreen;
